"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = momentPropType;

var _moment = require("moment");

function momentPropType(props, propName, componentName) {
  if ((0, _moment.isMoment)(props[propName]) && !props[propName].isValid()) {
    return new Error('Failed prop type: The prop `' + propName + '` supplied to' + ' `' + componentName + '` should be valid moment object, but its value is' + ' `' + props[propName] + '`');
  }
}

momentPropType.isRequired = function (props, propName, componentName) {
  if (!props[propName]) {
    return new Error("Failed prop type: The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`,\n            but its value is `").concat(props[propName], "`"));
  }

  return momentPropType(props, propName, componentName);
};